import { Controller } from "@hotwired/stimulus"
import { Notyf } from "notyf"
import 'notyf/notyf.min.css'

export default class extends Controller {
  static values = {
    type: { type: String, default: 'success' },
    message: { type: String, default: '完了しました' }
  }

  connect() {
    this.notyf = new Notyf({
      duration: 6000,
      position: {
        x: 'right',
        y: 'top'
      }
    })

    // 接続時に自動的に通知を表示
    this.notify()

    // 表示後に要素を自動で削除
    // this.element.remove()
  }

  notify() {
    if (this.notyf && this.messageValue) {
      this.notyf.open({
        type: this.typeValue,
        message: this.messageValue
      })
    }
  }
}
